module.exports = __webpack_public_path__ + "static/media/ghostbusters.3676a0f4.jpg";